"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _editSettingsConfig = _interopRequireDefault(require("./editSettingsConfig"));

var _meetingsUser = _interopRequireDefault(require("./meetingsUser"));

var _meetingsLinks = _interopRequireDefault(require("./meetingsLinks"));

var _emailProvider = _interopRequireDefault(require("./emailProvider"));

var _calendarInfo = _interopRequireDefault(require("./calendarInfo"));

var _customHostedDomains = _interopRequireDefault(require("./customHostedDomains"));

var _default = function _default(state, action) {
  var editSettingsConfig = (0, _editSettingsConfig.default)(function () {
    return state;
  });
  return (0, _redux.combineReducers)({
    meetingsUser: _meetingsUser.default,
    meetingsLinks: _meetingsLinks.default,
    editSettingsConfig: editSettingsConfig,
    emailProvider: _emailProvider.default,
    calendarInfo: _calendarInfo.default,
    customHostedDomains: _customHostedDomains.default
  })(state, action);
};

exports.default = _default;
module.exports = exports.default;